// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__27nYD","header":"MessagesList_header__3FdCU","chat":"MessagesList_chat__xk1G2"};